<template>
  <zm-button
      v-if='bookWithSpecialistLink'
      data-testid="checkout-button-475"
      :data-url='bookWithSpecialistLink'
      ref='specialLinkRef'
      target='_blank'
      class='opc-succezz_book-specialist'
      round
      plain
      size='large'
      :href='bookWithSpecialistLink'>
    {{ $t('billing.pbx.book_specialist_button') }}
  </zm-button>
</template>
<script>
import { mapGetters } from 'vuex';
import { sendGAbizInfo } from '@/views/checkout/utils'

export default {
  computed: {
    ...mapGetters(['successConfig']),
    bookWithSpecialistLink() {
      return this.successConfig.bookWithSpecialistLink;
    },
  },
  methods: {
    toSpecialList() {
      sendGAbizInfo(`purchase confirmation`, 'book with a specialist');
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.specialLinkRef) {
        this.$refs.specialLinkRef.$el.removeEventListener('click', this.toSpecialList.bind(this));
        this.$refs.specialLinkRef.$el.addEventListener('click', this.toSpecialList.bind(this));
      }
    });
  },
};
</script>
<style lang='scss' scoped>
.opc-succezz_book-specialist {
  &.zm-button--plain:not(.is-ghost) {
    border: 1px solid #0C5CFF;
  }

  /deep/ .zm-button__slot {
    color: #0C5CFF;
  }
}
</style>
